import { assign } from '../common/utils';

const initialState = {
    starLevel: -1
}

const orderDetail = (state = initialState, action) => {
    switch (action.type) {
        case 'starLevel':
            return assign({},state,{starLevel:action.starLevel});
        case 'starLevel_change':
            return assign(state, {
                starLevel: action.starLevel
            });
        
        default:
            return state;
    }
};

export default orderDetail;